import { ConnectFacebookDialog } from 'apps/wrapper/src/components/shared/patient-feedback/dialogs/connect-facebook-dialog/connect-facebook-dialog';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { EventConnectFacebook } from 'apps/wrapper/src/types/event-bus';
import { useEffect, useState } from 'react';

interface ConnectState {
  locationId: number;
  facebookAppId?: string | null;
  facebookPermissionScopes?: string | null;
}

export const ConnectFacebookEventListener = () => {
  const { listen, publishToIframes } = useEventBus();
  const [connectState, setConnectState] = useState<ConnectState | null>(null);

  useEffect(
    () =>
      listen('connectFacebook', (event: any) => {
        const data = (event as EventConnectFacebook).data;
        setConnectState({
          locationId: data.locationId,
          facebookAppId: data.settings?.facebookAppId,
          facebookPermissionScopes: data.settings?.facebookPermissionScopes
        });
      }),
    [listen]
  );

  if (!connectState) return null;

  return (
    <ConnectFacebookDialog
      open={true}
      locationId={connectState.locationId}
      facebookAppId={connectState.facebookAppId}
      facebookPermissionScopes={connectState.facebookPermissionScopes}
      onClose={() => setConnectState(null)}
      onConnected={(pageName) => {
        publishToIframes({
          messageType: 'facebookConnected',
          data: { locationId: connectState.locationId, facebookPageName: pageName }
        });
        setConnectState(null);
      }}
    />
  );
};
